import BaseAdsDetails from './BaseAdsDetails';

export default BaseAdsDetails;
